export const ERROR_CODES = {
  ATHLETE_PACKAGE: {
    BLOCKED_BY_INVOICE: 'ATHLETE_PACKAGE_BLOCKED_BY_UPCOMING_INVOICE',
  },
  COMMON: {
    NO_STATE_CHANGE: 'NO_STATE_CHANGE',
  },
} as const;
